<template>
  <div class="user-avatar" :style="containerStyle">
    <LazyImage
      v-if="avatarUrl"
      :src="avatarUrl"
      :width="size"
      :height="size"
    />
    <div v-else class="user-avatar__fallback">
      <fa-icon :icon="['fas', 'user-doctor']"></fa-icon>
    </div>
  </div>
</template>

<script>
import { rails_service_blob_path } from '../javascripts/routes'
import LazyImage from './lazy_image.vue'

export default {
  name: 'UserAvatar',
  components: {
    LazyImage
  },
  props: {
    user: {
      type: Object,
      default: null
    },
    size: {
      type: Number,
      default: 48
    }
  },
  computed: {
    avatar() {
      return this.user?.avatar || null
    },
    avatarUrl() {
      const directUrl = this.user?.avatar_url || this.avatar?.url
      if (directUrl) {
        return directUrl
      }
      if (this.avatar?.signed_id && this.avatar?.filename) {
        return rails_service_blob_path(this.avatar.signed_id, this.avatar.filename)
      }
      return ''
    },
    settings() {
      const raw = this.user?.avatar_settings || this.user?.profile?.avatar_settings || {}
      return {
        fit: raw.fit || 'cover',
        positionX: Number.isFinite(Number(raw.position_x)) ? Number(raw.position_x) : 50,
        positionY: Number.isFinite(Number(raw.position_y)) ? Number(raw.position_y) : 50,
        borderRadius: Number.isFinite(Number(raw.border_radius)) ? Number(raw.border_radius) : 50
      }
    },
    containerStyle() {
      const sizePx = `${this.size}px`
      return {
        width: sizePx,
        height: sizePx,
        borderRadius: `${this.settings.borderRadius}%`,
        fontSize: `${Math.round(this.size * 0.4)}px`,
        '--avatar-fit': this.settings.fit,
        '--avatar-pos-x': `${this.settings.positionX}%`,
        '--avatar-pos-y': `${this.settings.positionY}%`
      }
    },
  }
}
</script>

<style scoped lang="scss">
@use "../stylesheets/variables" as *;

.user-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: $primary-light-color-2;
  border: 1px solid #e3e7ee;
  line-height: 1;
  font-weight: 600;
  flex-shrink: 0;
}

.user-avatar .image__placeholder {
  width: 100%;
  height: 100%;
}

.user-avatar .image__item {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: var(--avatar-fit, cover);
  object-position: var(--avatar-pos-x, 50%) var(--avatar-pos-y, 50%);
}

.user-avatar__fallback {
  text-transform: uppercase;
}
</style>
